import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.authorization || initialState;

export const selectIsAuthorized = createSelector([selectSlice], state =>
  Boolean(state.user),
);
export const selectUser = createSelector([selectSlice], state => state.user);

export const selectCurrentUserId = createSelector(
  [selectSlice],
  state => state.user?.id,
);

export const selectPermissionsByCompany = createSelector(
  [selectSlice],
  state => state.permissionsByCompany,
);

export const selectRegisterLoading = createSelector(
  [selectSlice],
  state => state.registerLoading,
);

export const selectInitLoaded = createSelector(
  [selectSlice],
  state => state.initLoaded,
);

export const selectIsConsultant = createSelector(
  [selectSlice],
  state => state.user?.consultant,
);

export const selectUserCompanyAndEnvPermissions = createSelector(
  [selectSlice],
  ({ envPermissions, companyPermissions }) => ({
    envPermissions,
    companyPermissions,
  }),
);

export const selectPermissionsLoading = createSelector(
  [selectUserCompanyAndEnvPermissions],
  ({ envPermissions, companyPermissions }) =>
    envPermissions.loading || companyPermissions.loading,
);

export const selectPermissionsInitLoaded = createSelector(
  [selectUserCompanyAndEnvPermissions],
  ({ envPermissions, companyPermissions }) =>
    envPermissions.initLoaded && companyPermissions.initLoaded,
);

export const selectPermissions = createSelector(
  [selectSlice],
  ({
    envPermissions: { permissionsArr: envPerm },
    companyPermissions: { permissionsArr: compPerm },
  }) => {
    if (!compPerm) {
      return envPerm;
    }

    const getBiggerPermission = (first: 0 | 1 | 2, second: 0 | 1 | 2) => {
      return first > second ? first : second;
    };

    return {
      companyAdministration: getBiggerPermission(
        envPerm.companyAdministration,
        compPerm.companyAdministration,
      ),
      cultureAdministration: getBiggerPermission(
        envPerm.cultureAdministration,
        compPerm.cultureAdministration,
      ),
      fieldAdministration: getBiggerPermission(
        envPerm.fieldAdministration,
        compPerm.fieldAdministration,
      ),
      resourceAdministration: getBiggerPermission(
        envPerm.resourceAdministration,
        compPerm.resourceAdministration,
      ),
      taskAdministration: getBiggerPermission(
        envPerm.taskAdministration,
        compPerm.taskAdministration,
      ),
      recommendationPermission: getBiggerPermission(
        envPerm.recommendationPermission,
        compPerm.recommendationPermission,
      ),
      usersAdministration: getBiggerPermission(
        envPerm.usersAdministration,
        compPerm.usersAdministration,
      ),
      garageAdministration: getBiggerPermission(
        envPerm.garageAdministration,
        compPerm.garageAdministration,
      ),
      analytics: getBiggerPermission(envPerm.analytics, compPerm.analytics),
    };
  },
);
